import { LabelDetail } from '@bpm-web-app/components/pages';

const LabelDetailPage = () => <LabelDetail />;

export default LabelDetailPage;
